export default async function initializeMetaPixel(pixelId = null) {
  removeExistingMetaPixel();
  if (typeof document === "undefined") return;
  if (!pixelId) return;
  if (document.querySelector('script[src*="fbevents.js"]')) return;

  const script = document.createElement("script");
  script.type = "text/javascript";
  script.innerHTML = `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');fbq('init', '${pixelId}');`;
  document.head.appendChild(script);

  const noscript = document.createElement("noscript");
  noscript.innerHTML = `<img height="1" width="1" style="display:none"
src="https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1"
/>`;
  document.body.prepend(noscript);
}

export function removeExistingMetaPixel() {
  if (typeof document === "undefined") return;

  // Remove Meta Pixel scripts from head (inline bootstrap or external fbevents.js)
  const headScripts = document.head.querySelectorAll("script");
  headScripts.forEach((script) => {
    const isFbevents =
      script.innerHTML.includes("fbevents.js") ||
      (script.src && (script.src.includes("fbevents.js") || script.src.includes("connect.facebook.net")));
    if (isFbevents) script.remove();
  });

  // Remove noscript fallback (tracking pixel img) from body
  const bodyNoscripts = document.body.querySelectorAll("noscript");
  bodyNoscripts.forEach((ns) => {
    if (ns.innerHTML.includes("facebook.com/tr")) ns.remove();
  });

  // Clear globals so re-init runs cleanly
  if (typeof window !== "undefined") {
    delete window.fbq;
    delete window._fbq;
  }
}